export default "__VITE_ASSET__b849b2fe__"